import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import {
    getProductAssurance,
    getProductConditions,
    getProductProperties,
    registerProduct
} from "../actions/AdInsert.action";

const initialState:any=[];

const adInsertSlice = createSlice(
    {
        name:"adInsert",
        initialState : initialState,
        reducers:{resetAdInsert: () => initialState},
        extraReducers: (builder: ActionReducerMapBuilder<any>) => {
            builder.addCase(getProductAssurance.fulfilled, (state, action) => {
              return { ...state, getProductAssurance: action.payload };
            })
            builder.addCase(getProductProperties.fulfilled, (state, action) => {
              return { ...state, getProductProperties: action.payload };
            })
            builder.addCase(getProductConditions.fulfilled, (state, action) => {
              return { ...state, getProductConditions: action.payload };
            })
            builder.addCase(registerProduct.fulfilled, (state, action) => {
              return { ...state, registerProduct: action.payload };
            })

          }
    }
);

const { reducer } = adInsertSlice;
export const { resetAdInsert } = adInsertSlice.actions;

export default reducer;
